import { useNavigate } from 'react-router-dom';

import { useEffect } from 'react';

import { SplitFiestaLoading } from '@/components/common/SplitFiestaLoading';

import { queryClient } from '@/lib/queryClient';

import { useAuthStore } from '@/stores/authStore';

export function LogoutPage() {
  const logout = useAuthStore(state => state.logout);
  const navigate = useNavigate();

  useEffect(() => {
    // Clear all React Query cache to prevent data leakage between users
    queryClient.clear();

    // Logout from auth store
    logout();

    // Redirect to login page
    navigate('/login');
  }, [logout, navigate]);

  // Show loading while logging out
  return (
    <div className="min-h-screen bg-linear-to-b from-emerald-50 to-white dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <SplitFiestaLoading />
    </div>
  );
}
